import { ObservableFromFetch } from "../ObservableFromFetch"
import PortalLogoModel from "./Model/PortalLogoModel"

export default function PortalLogoInsert(logo: PortalLogoModel) {
    const requestBody = JSON.stringify(logo)
    return ObservableFromFetch<string>("FFOrderClinicEnrollment/InsertPortalLogo", requestBody)
}